// extracted by mini-css-extract-plugin
export default {"welcomeMessage":"home_welcomeMessage__N+roH"};